import QmImport from './src/main'

/* istanbul ignore next */
QmImport.install = function (Vue) {
  Vue.component(QmImport.name, QmImport)
}

export default QmImport
